import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import * as Sentry from "@sentry/react";

// Global CSS imports - moved from lazy-loaded components
// Note: Brand fonts are now loaded conditionally via loadBrandFonts() in ChatLayout/WizLayout
import "./styles/LiveChatStyle.css";
import "./styles/createCoupon.css";
import "./styles/Popup.css";
import "./App.css";
import "./index.css";

// Third-party CSS imports
import "react-phone-input-2/lib/style.css";
import "react-phone-input-2/lib/bootstrap.css";
import "react-datepicker/dist/react-datepicker.css";
import "rc-swipeout/assets/index.css";

import { store } from "./store/index";
import App from "./App";

["replaceState", "pushState"].forEach((method) => {
  const native = window.history[method].bind(window.history);
  window.history[method] = (...args) => {
    try {
      return native(...args);
    } catch (e) {
      if (e?.name !== "SecurityError") {
        throw e;
      }
    }
  };
});

if (
  import.meta.env.VITE_APP_SENTRY_KEY &&
  import.meta.env.VITE_APP_ENV !== "LOCAL"
) {
  Sentry.init({
    dsn: import.meta.env.VITE_APP_SENTRY_KEY,
    environment: import.meta.env.VITE_APP_ENV,
    denyUrls: [
      /scripts\.orb\.ee/i,
      /orb\.ee/i,
      /^chrome:\/\//i,
      /^chrome-extension:\/\//i,
      /^moz-extension:\/\//i,
      /^safari-(web-)?extension:\/\//i,
    ],
    ignoreErrors: [
      "zp_token is not defined",
      "Invalid call to runtime.sendMessage()",
      "window.webkit.messageHandlers",
      "WKWebView API client did not respond to this postMessage",
      "Non-Error promise rejection captured with value: Object Not Found Matching",
    ],
    beforeSend: function (event) {
      var e = event?.exception?.values?.[0];
      var value = e?.value || "";
      if (
        e?.type === "UnhandledRejection" &&
        (value.includes("Loading CSS chunk") ||
          value.includes("Failed to fetch dynamically imported module"))
      ) {
        return null;
      }
      return event;
    },
  });
}

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <Provider store={store}>
    <App />
  </Provider>,
);
